import * as React from 'react'
import { View, Text } from 'react-native'
import styled from '@theme/styled-components'

import Checkbox from '@components/checkbox/Checkbox'

import useI18n from '@i18n/useI18n'
import { COLORS, ICONS, IncidentTypeEnum } from '@components/incidentStatus/IncidentStatus'

interface Props {
  onSelectStatus: (status: IncidentStatus) => void
  selectedStatus: EtatWorkflowIncidentEnum[]
  incidents: IncidentResponse[]
}

export type IncidentStatus = {
  id: EtatWorkflowIncidentEnum

  icon: {
    name: IconName
    color: string
  }
  name: string
  quantity?: number
}

export const incidentStatus: IncidentStatus[] = Object.keys(ICONS).map((status) => ({
  id: status as EtatWorkflowIncidentEnum,
  icon: {
    name: ICONS[status as IncidentTypeEnum],
    color: COLORS[status as EtatWorkflowIncidentEnum].light,
  },
  name: `incidentStatus.${status}`,
}))

const StatusSelection = ({ onSelectStatus, selectedStatus, incidents }: Props) => {
  const i18n = useI18n()

  const quantities = React.useMemo(() => {
    return incidents.reduce<Record<EtatWorkflowIncidentEnum, number>>(
      (acc, curr) => {
        acc[curr.status as EtatWorkflowIncidentEnum] = acc[curr.status] + 1
        return acc
      },
      Object.keys(ICONS).reduce<Record<string, number>>((acc, curr) => {
        acc[curr] = 0
        return acc
      }, {})
    )
  }, [incidents])

  const renderCheckboxItem = (status: IncidentStatus) => {
    const hasQuantity = quantities[status.id] !== 0

    return (
      <StatusContainer key={status.name}>
        <Checkbox
          iconOnTheRight
          label={i18n.t(status.name)}
          onClick={() => onSelectStatus(status)}
          value={selectedStatus.some((e) => e === status.id)}
          icon={status.icon}
          info={hasQuantity ? quantities[status.id] : undefined}
        />
      </StatusContainer>
    )
  }

  return (
    <Section>
      <SectionTitle>{i18n.t('screens.incidentList.filters.modal.main.sections.status')}</SectionTitle>
      <View>{incidentStatus.map(renderCheckboxItem)}</View>
    </Section>
  )
}

const Section = styled(View)`
  margin-bottom: 32px;
`
const SectionTitle = styled(Text)`
  ${(props) => props.theme.fonts.Headline};
  margin-bottom: 8px;
`
const StatusContainer = styled(View)`
  margin-bottom: 25px;
`

export default StatusSelection
